import { localStorageLang, localStorageDevice, localStorageAuthToken, MYS4C_ROOT_PROTOCOL, MYS4C_ROOT_HOST, MYS4C_ROOT_LOCAL, MYS4C_PERSONALIZE_ROOT_HOST_STAGE, MYS4C_PERSONALIZE_ROOT_HOST_LIVE } from './constants';
import { isAppLocal } from './helpers';

export const myS4cLocal = "https://test3.s4c.cymru/capi";
export const myS4cLive = "https://test3.s4c.cymru/capi";

/*export const myS4cLocal = "http://34.241.87.45:32769/capi";
export const myS4cLive = "http://34.241.87.45:32769/capi";*/

export function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & (0x3 | 0x8))).toString(16);
    });
    return uuid;
};

export function getDeviceID() {
    var devID = localStorage.getItem(localStorageDevice);
    if (devID === null) {
        devID = generateUUID();
        localStorage.setItem(localStorageDevice, devID, Infinity, '/');
    }
    return devID;
};

export function checkLangMyS4c(lang) {
    let language;
    if(!lang) {
        language = localStorage.getItem(localStorageLang) === null ? 0 : parseInt(localStorage.getItem(localStorageLang), 10);
    } else {
        language = lang;
    }
    return language === 0 ? 'W' : 'E';
}

export function formFormatDob(dob) {
    let dateForm = dob;
    let dateSplit = [];
    if(dob && dob.length > 0) {
        if(dob.includes("/")) {
            dateSplit = dob.split("/");
            dateForm = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
        } else {
            dateSplit = dob.split("-");
            dateForm = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;
        }
        return dateForm;
    }
}


export function getTokenID() {
    return localStorage.getItem(localStorageAuthToken) === null ? false : localStorage.getItem(localStorageAuthToken);
};

export function getItemName(pId, tokenId) {
  let ItemName=false;
  if(tokenId && pId) {
    const today = new Date();
    const tokenDate = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    const tokenSplit = tokenId.split('-');
    ItemName = `${tokenSplit[0]}-${tokenSplit[1]}-${pId}-${tokenDate}`;
  }

  return ItemName;
}

export function myS4CBaseUrl(localOverride) {
	const envId = window.ENV_ID === 'live' ? 'www' : window.ENV_ID;
	const baseUrl = 
  isAppLocal() 
    ? localOverride 
      ? localOverride 
      : MYS4C_ROOT_LOCAL
    : `${MYS4C_ROOT_PROTOCOL}${envId}${MYS4C_ROOT_HOST}`;
	return baseUrl;
}

export function myS4CApiPatch() {
  const path = window.CLIC_BASENAME.replace('/','');
return path;
}

export function isInAddToList(id, myList) {
  return  myList && !myList.error && (myList.length > 0 || Object.keys(myList).length) ? myList.find(item => item.fav_id === parseInt(id, 10)) : false;
}

export function addToList(id, myList) {
  if (!isInAddToList(id,myList)){
    if (myList instanceof Array){
      myList.push({fav_id:parseInt(id, 10)});
    }
  }
  return myList
}

export function removeFromToList(id, myList) {
  if (isInAddToList(id,myList)){
    let found = myList.findIndex(item => item.fav_id === parseInt(id, 10));
    if(found > -1){
      myList.splice(found,1); // remove offender
    }
  }
  return myList
}

export function myS4CPersonalizeBaseUrl() {
	return window.ENV_ID === 'live' || window.ENV_ID === 'www' || window.ENV_ID === 'beta' ? `${MYS4C_PERSONALIZE_ROOT_HOST_LIVE}` : `${MYS4C_PERSONALIZE_ROOT_HOST_STAGE}`;
}